/* eslint-disable no-param-reassign */

const mutations = {
  UPDATE_WINDOW_WIDTH(state, val) {
    state.windowWidth = val
  },
  SetFeaturedInventory(state, val) {
    state.featuredInventory = val
  },
  SetShowedConstruction(state, val) {
    state.showedConstruction = val
  },
  SetMailPActive(state, val) {
    state.mailPActive = val
  },
  AddEmailItem(state, val) {
    if (val == 'single') {
      state.emailInventory.push(JSON.parse(JSON.stringify(state.emailInventory.find(x => x.type == 'single'))))
    } else if (val == 'listing') {
      state.emailInventory.push(JSON.parse(JSON.stringify(state.emailInventory.find(x => x.type == 'listing'))))
    }
  },
  SetMJMLHTML(state, val) {
    state.mjmlHTML = val
  },
}

export default mutations
